import { Banner } from "@modules/home/types/banner"

const BACKEND_URL = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL

export async function fetchBanners(): Promise<Banner[]> {
  const endpoint = `${BACKEND_URL}/store/banners`

  try {
    const response = await fetch(endpoint, {
      method: "GET",
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch banners: ${response.statusText}`)
    }
    const data = await response.json()
    return data.data.filter((banner: Banner) => banner.is_active === 1)
  } catch (error: any) {
    if (error?.isRateLimit || error?.status === 429) {
      console.warn("Rate limit error in fetching banners, returning empty")
      return []
    }
    console.error("Failed to fetch banners:", error)
    return []
  }
}
